import type { Component } from 'solid-js'

import UserAvatar from '../UserAvatar'

export interface UserInfoCellUser {
  readonly first_name?: string | null
  readonly last_name?: string | null
  readonly email?: string | null
  readonly image_url?: string | null
}

export interface UserInfoCellProps {
  readonly user: UserInfoCellUser
}

const UserInfoCell: Component<UserInfoCellProps> = (props) => {
  const displayName = () =>
    [props.user.first_name, props.user.last_name].filter(Boolean).join(' ') || props.user.email || 'Anonymous User'

  const avatarName = () =>
    [props.user.first_name, props.user.last_name].filter(Boolean).join(' ') || props.user.email || 'User avatar'

  return (
    <div class="flex min-w-0 items-center gap-3">
      <UserAvatar src={props.user.image_url} name={avatarName()} class="h-10 w-10 min-w-10 rounded-full object-cover" />
      <div class="flex min-w-0 flex-col">
        <span class="truncate text-sm font-medium text-gray-700" title={displayName()}>
          {displayName()}
        </span>
        <span class="truncate text-sm text-gray-500" title={props.user.email ?? ''}>
          {props.user.email}
        </span>
      </div>
    </div>
  )
}

export default UserInfoCell
